/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Source_Status_Days_AgoInputs */

const en_source_status_days_ago = /** @type {(inputs: Source_Status_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} days ago`)
};

const nl_source_status_days_ago = /** @type {(inputs: Source_Status_Days_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dagen geleden`)
};

/**
* | output |
* | --- |
* | "{count} days ago" |
*
* @param {Source_Status_Days_AgoInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const source_status_days_ago = /** @type {((inputs: Source_Status_Days_AgoInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_Status_Days_AgoInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_source_status_days_ago(inputs)
	return en_source_status_days_ago(inputs)
});